var map = {
	"./arrow-left.svg": "9ba7",
	"./arrow.svg": "3c0a",
	"./audio.svg": "2aed",
	"./blur.svg": "b835",
	"./burger-close.svg": "a263",
	"./chat-disabled.svg": "a198",
	"./chat.svg": "9793",
	"./close.svg": "6282",
	"./info.svg": "0c83",
	"./kamera-disabled.svg": "ae50",
	"./kamera.svg": "5397",
	"./linux.svg": "129b",
	"./mac.svg": "5387",
	"./mic-disabled.svg": "8745",
	"./mic.svg": "280d",
	"./participants-disabled.svg": "5b84",
	"./participants.svg": "658f",
	"./phone.svg": "9855",
	"./poll.svg": "6164",
	"./settings.svg": "cbdc",
	"./sharescreen.svg": "6c0d",
	"./trash.svg": "dab5",
	"./user-disabled.svg": "ab70",
	"./user.svg": "7393",
	"./windows.svg": "053e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";